var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "stats-mpas-sidebar visible-lg" },
      _vm._l(_vm.availableAreas, function (area) {
        return _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedAreas,
                expression: "selectedAreas",
              },
            ],
            attrs: { type: "checkbox", id: "id" + area },
            domProps: {
              value: area,
              checked: Array.isArray(_vm.selectedAreas)
                ? _vm._i(_vm.selectedAreas, area) > -1
                : _vm.selectedAreas,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.selectedAreas,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = area,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.selectedAreas = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.selectedAreas = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.selectedAreas = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "id" + area } }, [_vm._v(_vm._s(area))]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mpas-and-byelaws-container" },
      [
        _c("div", { staticClass: "visible-mobile stats-mpas-dropdown" }, [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleDropdown.apply(null, arguments)
                },
              },
            },
            [
              _c("span", [_vm._v("Choose areas of interest")]),
              _vm._v(" "),
              _c("font-awesome-icon", { attrs: { icon: _vm.dropdownIcon } }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dropdownVisible
            ? _c(
                "div",
                {
                  staticClass: "dropdown-items",
                  attrs: { id: "stats-mpas-mobile-dropdown", tabindex: "1" },
                  on: {
                    blur: function ($event) {
                      _vm.dropdownVisible = false
                    },
                  },
                },
                _vm._l(_vm.availableAreas, function (area) {
                  return _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAreas,
                          expression: "selectedAreas",
                        },
                      ],
                      attrs: { type: "checkbox", id: "id" + area },
                      domProps: {
                        value: area,
                        checked: Array.isArray(_vm.selectedAreas)
                          ? _vm._i(_vm.selectedAreas, area) > -1
                          : _vm.selectedAreas,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedAreas,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = area,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.selectedAreas = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedAreas = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedAreas = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "id" + area } }, [
                      _vm._v(_vm._s(area)),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "mpas-and-byelaws" } }),
        _vm._v(" "),
        _c("area-legend"),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clearfix" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "chart-title" }, [
      _vm._v(
        "\n        Charts showing how different areas fall within MPAs and byelaws restricting bottom towed fishing gear. Use the\n        "
      ),
      _c("span", { staticClass: "visible-lg-inline" }, [_vm._v("checkboxes")]),
      _vm._v(" "),
      _c("span", { staticClass: "visible-mobile-inline" }, [
        _vm._v("dropdown"),
      ]),
      _vm._v("\n        to add or remove areas of interest.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }